


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import question from '../../../components/question.vue';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import noImg from '@/assets/img/common/no-img.svg';
import phoneCode from '@/assets/js/phone_code.js';
import Tanchuan from '@/assets/img/common/tanchuan.svg';
import { getCompanyInfo } from '@/model/CompanyInfo';
import EventBus from '@/utils/eventBus';
import {CUSTOM_POPPINS_FONT_COMPANY_ID, CUSTOM_TENOR_SANS_FONT_COMPANY_ID } from '@/utils/getFontFaceList';
import ExtendedCountdown, { CountdownConfig } from '@/components/wheel/ExtendedCountdown.vue';
import {
  extCountdownPresetDigitFontFamily,
  extCountdownPresetDigitFontSize,
  extCountdownPresetSeparatorStyle,
  extCountdownPresetSuffixTextColor
} from '@/components/wheel/extendedCountdown/extendedCountdownPresets';
import {
  extendedCountdownHorizontalPadding,
  extendedCountdownVerticalMargin,
  extendedCountdownVerticalPadding
} from '@/components/wheel/extendedCountdown/extendedCountdownModel';
import { isEnableExtendedPopCountdown , isEnableWheelCouponSetting, isEnablePrivacySetting, isEnableCustomStep, DISABLE_CUSTOM_STEP_TPLID, isEnableBannerEnglishPunctuationSpacing, isEnableCloseButtonAdvanced, isEnableOnlyNewUserCustomStep, DISABLE_CUSTOM_STEP_TPLID_NEW, isOnlyNewUserTemplate } from '@/utils/experiment';
import { getQueryVariable } from '@/services/api';
import { LogGetter } from '@/utils/LogGetter';
import { getMiddlePageScopedField, isMiddlePage } from '../../utils/stepPages';
import CloseButtonPreviewIcon from './CloseButtonPreviewIcon.vue';

@Component({
  components: {
    'component-question': question,
    ExtendedCountdown,
    CloseButtonPreviewIcon,
  }
})
export default class pop extends Vue {
  @Prop(String)
  activePageSetting!: string;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Object)
  formData!: PopSettingsVO;

  @Prop(String)
  couponCopyText!: string;

  @Prop(String)
  middleCouponCopyText!: string;

  @Prop(String)
  device!: string;

  @Prop({ type: Boolean, default: false })
  isStyleSetting!: boolean;

  @Prop(Array)
  countryList!: any;

  @Prop(String)
  id?: any;

  @Prop(Number)
  templateId?: Number;

  @Prop(Number)
  popWindowWheel?: Number;

  @Prop(Number)
  successPageType?: Number;

  @Prop({ type: String, default: 'success' })
  subscribeStatus!: string;

  @Prop({ type: String, default: '1' })
  step!: string;

  noImg = noImg;
  countDownM: string = '05';
  countDownS: string = '00';

  imgNameObj = {
    LeftTop: { top: '20px', left: '20px' },
    RightTop: { top: '20px', right: '20px' },
    LeftMiddle: { top: '47%', left: '20px' },
    RightMiddle: { top: '47%', right: '20px' },
    LeftBottom: { bottom: '20px', left: '20px' },
    RightBottom: { bottom: '20px', right: '20px' }
  };
  Email = '';

  public img = {
    Tanchuan
  };

  imgWidth = '100%';

  imgHeight = 'auto';

  iconDynamicSizing = false;

  selectedCountry = {
    countryAbbreviation: 'US',
    phoneCode: '+1'
  };

  value1 = '';

  checkList = [];

  discountTypeUpdated = 0;

  formDataStart: any = this.formData;

  async created(): Promise<void> {
    this.formData.position.iconShow = this.formData.position.iconShow || true;
  }

  get isMiddlePageSetting() {
    return isMiddlePage(this.activePageSetting);
  }

  get middlePageScopedKeyPrefix() {
    return this.isMiddlePageSetting ? this.activePageSetting : 'middle';
  }

  getMiddleTypesettingValue(field: string) {
    const typesetting = this.formData.typesetting as any;
    if (!typesetting) return undefined;
    const scopedKey = getMiddlePageScopedField(this.middlePageScopedKeyPrefix, field);
    return typesetting[scopedKey] ?? typesetting[field];
  }

  getMiddleScopedValue(container: any, field: string) {
    if (!container) return undefined;
    const scopedKey = getMiddlePageScopedField(this.middlePageScopedKeyPrefix, field);
    return container[scopedKey] ?? container[field];
  }

  get middleShowClassName() {
    return `cartx-b-show__${this.middlePageScopedKeyPrefix}`;
  }

  getMiddleRuleValue(field: string) {
    return this.getMiddleScopedValue(this.formData.rules as any, field);
  }

  getMiddleTextValue(field: string) {
    return this.getMiddleScopedValue(this.formData.texts as any, field);
  }

  getScopedMiddleStyleKey(baseKey: string) {
    if (!this.isMiddlePageSetting || !/__middle(?!\d)/.test(baseKey)) {
      return baseKey;
    }
    const alreadyScopedKey = `__${this.middlePageScopedKeyPrefix}`;
    if (baseKey.includes(alreadyScopedKey)) {
      return baseKey;
    }
    return baseKey.replace(/__middle(?!\d)/g, `__${this.middlePageScopedKeyPrefix}`);
  }

  getScopedStyleMap(baseKey: string) {
    const styleMap = this.formData.styles?.styleMap || {};
    const scopedKey = this.getScopedMiddleStyleKey(baseKey);
    return styleMap[scopedKey] || styleMap[baseKey] || {};
  }

  get currentMiddleLeftAdImage() {
    return this.getMiddleTypesettingValue('middleLeftAdImage');
  }

  get currentMiddleRightAdImage() {
    return this.getMiddleTypesettingValue('middleRightAdImage');
  }

  get startOrEnd() {
    console.log('startOrEnd', this.activePageSetting, this.formData);
    if (this.isTieredMiddleCouponPage) {
      return [];
    }
    // 根据 activePageSetting 返回对应的表单数据
    if (this.activePageSetting === 'start') {
      return this.formData.start || [];
    } else if (this.activePageSetting === 'end') {
      return this.formData.end || [];
    } else if (this.isMiddlePageSetting) {
      return (this.formData as any)[this.activePageSetting] || [];
    }

    return this.formData.start || [];
  }

  /** 与 C 端一致：开启关闭按钮高级设置且非嵌入式弹窗时，预览使用 cartx-b-close-v2 + SVG scale */
  get enableClosePreviewV2() {
    return isEnableCloseButtonAdvanced() && this.triggerEventType !== 7;
  }

  // 获取当前页面的关闭按钮完整配置
  get currentCloseButtonConfig() {
    const rules = this.formData.rules;
    const cover = this.formData.cover;
    let config = null;

    // 根据页面类型获取对应的 closeButtonConfig
    if (this.activePageSetting === 'cover') {
      config = cover?.closeButtonConfig;
    } else if (this.activePageSetting === 'end') {
      config = rules.endCloseButtonConfig;
    } else if (this.isMiddlePageSetting) {
      config = this.getMiddleRuleValue('middleCloseButtonConfig');
    } else if (this.activePageSetting === 'start') {
      config = rules.closeButtonConfig;
    }

    // 老配置字段是表单（非灰度店铺）实际写入的目标
    let oldColor: string | undefined;
    if (this.activePageSetting === 'cover') {
      oldColor = cover?.closeColor || rules.closeColor;
    } else if (this.activePageSetting === 'end') {
      oldColor = rules.endCloseColor || rules.closeColor;
    } else if (this.isMiddlePageSetting) {
      oldColor = this.getMiddleRuleValue('middleCloseColor') || rules.closeColor;
    } else {
      oldColor = rules.closeColor;
    }

    // 非灰度店铺：表单只写老字段，优先以老字段为准（避免被 pop/index.vue 迁移生成的
    // closeButtonConfig.iconColor 冻结住颜色，导致用户改色不生效）
    // 灰度店铺：表单写新字段并同步回老字段，优先用新字段
    const newColor = config?.iconColor;
    const iconColor = isEnableCloseButtonAdvanced()
      ? (newColor || oldColor)
      : oldColor;

    return {
      iconColor: iconColor || '#463C32',
      size: config?.size || '18px',
      position: config?.position || 'right-top',
      bgMode: config?.bgMode || 'none',
      bgColor: config?.bgColor || 'rgba(0,0,0,0)',
    };
  }

  get closeColor() {
    // 优先使用新配置的 iconColor
    return this.currentCloseButtonConfig.iconColor;
  }

  // 关闭按钮尺寸（数字）
  get closeButtonSize() {
    return parseInt(this.currentCloseButtonConfig.size, 10);
  }

  // 关闭按钮外层样式 - 按照设计规范：热区=配置尺寸，icon等比缩小居中，位置固定6px
  get closeButtonStyle() {
    const config = this.currentCloseButtonConfig;
    const sizeNum = this.closeButtonSize; // 热区尺寸（18px-40px）
    const hasBg = config.bgMode !== 'none';

    // 基础样式 - 热区尺寸严格等于配置值
    const style: Record<string, string> = {
      position: 'absolute',
      top: '6px',
      zIndex: '10',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      width: `${sizeNum}px`,
      height: `${sizeNum}px`,
    };

    if (this.enableClosePreviewV2) {
      style.boxSizing = 'border-box';
    }

    // 位置 - 固定6px，不随尺寸变化
    if (config.position === 'left-top') {
      style.left = '6px';
    } else {
      style.right = '6px';
    }

    // 背景样式（v2 背景由 SVG 内部绘制）
    if (hasBg && !this.enableClosePreviewV2) {
      style.backgroundColor = config.bgColor;
      if (config.bgMode === 'circle') {
        style.borderRadius = '50%';
      } else if (config.bgMode === 'square') {
        style.borderRadius = '4px';
      }
    }

    return style;
  }

  // icon尺寸 - 基于热区等比缩小（18px热区对应9.45px icon，比例约0.525）
  get closeIconSize() {
    const sizeNum = this.closeButtonSize;
    return Math.round(sizeNum);
  }

  // 获取当前页面的倒计时显示状态
  get currentCountDownShow() {
    if (this.isMiddlePageSetting) {
      const middleShow = this.getMiddleRuleValue('middleCountDownShow');
      if (typeof middleShow === 'boolean') return middleShow;
      return this.formData.rules.countDownShow;
    } else if (this.activePageSetting === 'end') {
      const endShow = this.formData.rules.endCountDownShow;
      if (typeof endShow === 'boolean') return endShow;
      return this.formData.rules.countDownShow;
    }
    return this.formData.rules.countDownShow;
  }

  // 获取当前页面的倒计时样式键名
  get currentTimeItemStyleKey() {
    // if (this.activePageSetting === 'middle') {
    //   return 'cartx-b-time-item__middle';
    // } else if (this.activePageSetting === 'end') {
    //   return 'cartx-b-time-item__end';
    // }
    return 'cartx-b-time-item';
  }

  // 获取当前页面的倒计时样式对象
  get currentTimeItemStyle() {
    return this.formData.styles.styleMap[this.currentTimeItemStyleKey] || {};
  }

  // 获取当前页面的标题文本
  get currentTitleText() {
    const titleMap: { [key: string]: string } = {
      start: this.formData.texts.topTitle || '',
      middle: (this.formData.texts as any).middleTopTitle || '',
      end: this.formData.texts.endTopTitle || ''
    };
    return this.isMiddlePageSetting
      ? (this.getMiddleTextValue('middleTopTitle') || '')
      : (titleMap[this.activePageSetting] || '');
  }

  // 获取当前页面的标题样式键名
  get currentTitleStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-title',
      middle: 'cartx-b-title__middle',
      end: 'cartx-b-title-end'
    };
    return this.isMiddlePageSetting
      ? this.getScopedMiddleStyleKey(styleKeyMap.middle)
      : (styleKeyMap[this.activePageSetting] || 'cartx-b-title');
  }

  // 获取当前页面的标题样式对象
  get currentTitleStyle() {
    const styleKey = this.currentTitleStyleKey;
    const styleMap = this.getScopedStyleMap(styleKey);
    const baseFontSize = (styleMap['font-size'] as string) || '16px';
    const fontSize = this.device === 'desktop' ? baseFontSize : 375 * (parseFloat(baseFontSize) / 500) + 'px';

    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family'],
      fontSize,
      ...(this.formData.rules.adapterText &&
        this.activePageSetting !== 'end' && {
          fontWeight: 'bold',
          ...(this.device === 'phone' && { fontSize: this.triggerEventType === 2 ? '24px' : '14px' })
        })
    };
  }

  // 获取当前页面的副标题文本
  get currentSubtitleText() {
    const textMap: { [key: string]: string } = {
      start: this.formData.texts.topSubTitle || '',
      middle: (this.formData.texts as any).middleTopSubTitle || '',
      end: this.formData.texts.endTopSubTitle || ''
    };
    return this.isMiddlePageSetting
      ? (this.getMiddleTextValue('middleTopSubTitle') || '')
      : (textMap[this.activePageSetting] || '');
  }

  // 获取当前页面的副标题样式键名
  get currentSubtitleStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-subtitle',
      middle: 'cartx-b-subtitle__middle',
      end: 'cartx-b-subtitle-end'
    };
    return this.isMiddlePageSetting
      ? this.getScopedMiddleStyleKey(styleKeyMap.middle)
      : (styleKeyMap[this.activePageSetting] || 'cartx-b-subtitle');
  }

  // 获取当前页面的副标题样式对象
  get currentSubtitleStyle() {
    const styleKey = this.currentSubtitleStyleKey;
    const styleMap = this.getScopedStyleMap(styleKey);
    const baseFontSize = (styleMap['font-size'] as string) || '16px';
    const fontSize = this.device === 'desktop' ? baseFontSize : parseFloat(baseFontSize) / 1.33 + 'px';

    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family'],
      fontSize,
      ...(this.formData.rules.adapterText &&
        this.activePageSetting !== 'end' && {
          ...(this.device === 'phone' && { fontSize: this.triggerEventType === 2 ? '14px' : '20px' })
        })
    };
  }
  /**
   * AB 命中且未选择「旧版时长与样式」时，用扩展配置驱动预览；
   * `countDownShowLegacyUi === true` 时与 C 端一致，仍走旧版 `cartx-b-time` 展示。
   */
  get enableExtendedPopCountdownPreview() {
    return (
      isEnableExtendedPopCountdown() &&
      !!this.formData.countdown &&
      this.currentCountDownShow &&
      this.formData.rules.countDownShowLegacyUi !== true
    );
  }

  parseExtendedCountdownEndTimestamp(endDate?: string): number {
    const s = String(endDate || '').trim();
    const asNum = Number(s);
    if (!Number.isNaN(asNum) && asNum > 1e11) return asNum;
    return Date.parse(s.replace(/-/g, '/'));
  }

  /**
   * 与 `extendedCountdownPreviewParts` 相同的剩余秒数解析（固定日期优先用结束时间，否则用期限/兜底 countDown）。
   */
  get extendedCountdownPreviewResolvedTotalSec(): number {
    const cd = this.formData.countdown!;
    const r = cd.rules;
    let totalSec = 0;
    if (r.type === 'fixed_date' && r.endDate) {
      const t = this.parseExtendedCountdownEndTimestamp(r.endDate);
      if (!Number.isNaN(t)) {
        totalSec = Math.max(0, Math.floor((t - Date.now()) / 1000));
      }
    }
    if (r.type !== 'fixed_date' || !r.endDate || totalSec === 0) {
      const d = r.duration || {};
      totalSec =
        (Number(d.days) || 0) * 86400 +
        (Number(d.hours) || 0) * 3600 +
        (Number(d.minutes) || 0) * 60 +
        (Number(d.seconds) || 0);
      if (totalSec <= 0) {
        totalSec = Math.max(0, Number(this.formData.rules.countDown) || 0);
      }
    }
    return totalSec;
  }

  /**
   * 固定日期且剩余不足 24 小时：预览可走线上旧版三格（无底部单位标签）。
   * 开启「时间单位（底部标签）」时必须 false，否则会抢走 stack 分支导致 HH/MM/SS 下无 DD/HH/MM/SS 文案。
   */
  get extendedCountdownPreviewUseOnlineLegacyLayout(): boolean {
    const cd = this.formData.countdown;
    if (!cd) return false;
    if (cd.styles?.showTimeUnitLabels === true) return false;
    const r = cd.rules;
    if (r.type === 'fixed_duration') return false;
    if (r.type === 'fixed_date' && r.endDate) {
      const t = this.parseExtendedCountdownEndTimestamp(r.endDate);
      if (Number.isNaN(t)) return false;
      const ts = Math.max(0, Math.floor((t - Date.now()) / 1000));
      return ts < 86400;
    }
    return false;
  }

  /** 与旧版 `cartx-b-time` 一致的三段文案：固定日期不足 24h 时展示；不足 1h 为 分:秒 两格 */
  get extendedCountdownPreviewLegacyTripleValues(): string[] {
    const cd = this.formData.countdown!;
    const r = cd.rules;
    const ts = this.extendedCountdownPreviewResolvedTotalSec;
    const pad2 = (n: number) => (n < 10 ? '0' : '') + n;
    const dp = cd.styles.displayParts || {};
    const showHMS = dp.showHMS !== false;
    const showSeconds = dp.showSeconds !== false;

    // 不足 1 小时或已过期：仅分:秒两格（不含 HH）
    if (r.type === 'fixed_date' && ts < 3600) {
      const mm = pad2(Math.floor(ts / 60));
      const ss = pad2(ts % 60);
      if (!showHMS) return ['00', '00'];
      if (!showSeconds) return [mm];
      return [mm, ss];
    }

    const hh = pad2(Math.floor((ts % 86400) / 3600));
    const mm = pad2(Math.floor((ts % 3600) / 60));
    const ss = pad2(ts % 60);
    if (!showHMS) return ['00', '00', '00'];
    if (!showSeconds) return [hh, mm, '00'];
    return [hh, mm, ss];
  }

  /**
   * 固定日期不足 24h 走线上三格布局时沿用扩展外边距/对齐/底衬。
   * 预设 2、4 有单位间分隔符，gap 置 0 以免与冒号叠出双倍间距。
   * 预设 1、3 隐藏分隔符，须与 slot/stack 一致保留 6px 间距；不可写死 gap:0，否则会覆盖样式表且内联优先级更高。
   */
  get extendedCountdownPreviewOnlineLegacyRowStyle() {
    const v = this.extendedCountdownPreviewVariant;
    const gap = v === 1 || v === 3 ? '6px' : '0';
    return {
      ...this.extendedCountdownPreviewRowStyle,
      gap
    };
  }

  /** 扩展预览：是否展示 DD/HH/MM/SS 底部标签 */
  get extendedCountdownPreviewShowUnitLabels() {
    return this.formData.countdown?.styles?.showTimeUnitLabels === true;
  }

  get extendedCountdownPreviewUnitLabelStyle() {
    const s = this.formData.countdown!.styles;
    const fs = s.suffixFontSize != null ? `${s.suffixFontSize}px` : '14px';
    const suffixColorRaw = s.suffixTextColor;
    const labelColor =
      suffixColorRaw != null && String(suffixColorRaw).trim() !== ''
        ? String(suffixColorRaw).trim()
        : extCountdownPresetSuffixTextColor(s.variant);
    return {
      color: labelColor,
      fontSize: fs,
      fontFamily: s.suffixFontFamily || s.fontFamily,
      fontWeight: 400,
      lineHeight: 1.2,
      marginTop: '6px',
      textAlign: 'center' as const
    };
  }

  get extendedCountdownSepChar() {
    const ch = this.formData.countdown?.styles?.separator?.char;
    return ch != null && String(ch) !== '' ? String(ch) : ':';
  }

  get extendedCountdownPreviewSepStyle() {
    const s = this.formData.countdown!.styles;
    const digitFs = s.fontSize != null ? `${s.fontSize}px` : '20px';
    const presetSep = extCountdownPresetSeparatorStyle(String(s.variant || '1'));
    const sepColorRaw = s.separator?.color;
    const color =
      sepColorRaw != null && String(sepColorRaw).trim() !== ''
        ? String(sepColorRaw).trim()
        : presetSep.color || '#000000';
    const fontSize =
      s.separator?.fontSize != null
        ? `${s.separator.fontSize}px`
        : presetSep.fontSize != null
          ? `${presetSep.fontSize}px`
          : digitFs;
    const fontWeight =
      s.separator?.bold != null ? (s.separator.bold ? 'bold' : undefined) : presetSep.bold ? 'bold' : undefined;
    return { color, fontSize, fontWeight };
  }

  get extendedCountdownPreviewDigitTextStyle() {
    const s = this.formData.countdown!.styles;
    const variant = String(s.variant || '1');
    const fs = s.fontSize != null ? Number(s.fontSize) : extCountdownPresetDigitFontSize(variant);
    const fontFamilyRaw = s.fontFamily != null ? String(s.fontFamily).trim() : '';
    const fontFamily = fontFamilyRaw || extCountdownPresetDigitFontFamily(variant) || undefined;
    return {
      color: s.textColor || '#ffffff',
      fontSize: `${fs}px`,
      fontFamily,
      fontWeight: 700
    };
  }

  get extendedCountdownPreviewDigitBoxStyle() {
    const db = this.formData.countdown!.styles.digitBackground || {};
    const br = db.borderRadius != null ? `${db.borderRadius}px` : '4px';
    // 边框宽度 / 颜色：与 B 端表单项一并关闭，预览不显式边框；恢复时取消注释以下四行并删掉 border* undefined
    // const bw = db.borderWidth != null && Number(db.borderWidth) > 0 ? `${db.borderWidth}px` : undefined;
    const enabled = db.enabled !== false;
    return {
      background: enabled ? db.color || '#333333' : 'transparent',
      borderRadius: br,
      borderWidth: undefined,
      borderStyle: undefined,
      borderColor: undefined,
      // borderWidth: bw,
      // borderStyle: bw ? 'solid' : undefined,
      // borderColor: db.borderColor
    };
  }

  get extendedCountdownPreviewRowStyle() {
    const s = this.formData.countdown!.styles;
    const sp = s.spacing || {};
    const pad = s.padding || {};
    const a = s.alignment || 'center';
    const jc = a === 'left' ? 'flex-start' : a === 'right' ? 'flex-end' : 'center';
    const horizPad = extendedCountdownHorizontalPadding(pad, sp);
    const vertMargin = extendedCountdownVerticalMargin(sp);
    const vertPad = extendedCountdownVerticalPadding(s.componentBackground, pad);
    return {
      display: 'flex',
      flexDirection: 'row' as const,
      justifyContent: jc,
      alignItems: 'center',
      flexWrap: 'nowrap' as const,
      marginTop: vertMargin.marginTop,
      marginBottom: vertMargin.marginBottom,
      paddingTop: vertPad.paddingTop,
      paddingBottom: vertPad.paddingBottom,
      paddingLeft: horizPad.paddingLeft,
      paddingRight: horizPad.paddingRight,
      backgroundColor: s.componentBackground || undefined
    };
  }

  get extendedCountdownPreviewUnitLabelStackedStyle() {
    const u = this.extendedCountdownPreviewUnitLabelStyle;
    return { ...u, marginTop: 0 };
  }

  /** 扩展预览：固定期限为 分:秒:毫秒位预览固定 00；固定日期为 DD/HH/MM/SS */
  get extendedCountdownPreviewParts(): { value: string; unit: string }[] {
    const cd = this.formData.countdown!;
    const r = cd.rules;
    const st = cd.styles;
    const dp = st.displayParts || {};
    const totalSec = this.extendedCountdownPreviewResolvedTotalSec;

    // 固定期限：分 : 秒 : 毫秒位预览固定 00（与线上一致，非实时跳动）
    if (r.type === 'fixed_duration') {
      const pad2 = (n: number) => (n < 10 ? '0' : '') + n;
      const mm = pad2(Math.floor(totalSec / 60));
      const ss = pad2(totalSec % 60);
      const ms = '00';
      const showHMS = dp.showHMS !== false;
      const showSeconds = dp.showSeconds !== false;
      const out: { value: string; unit: string }[] = [];
      if (showHMS) {
        out.push({ value: mm, unit: 'MM' });
        out.push({ value: ss, unit: 'SS' });
        if (showSeconds) {
          out.push({ value: ms, unit: 'MS' });
        }
      }
      if (out.length === 0) {
        return [
          { value: mm, unit: 'MM' },
          { value: ss, unit: 'SS' },
          { value: ms, unit: 'MS' }
        ];
      }
      return out;
    }

    // 固定日期不足 1 小时或已过期：仅展示 MM / SS（不含 HH、不含 MS）
    if (r.type === 'fixed_date' && totalSec < 3600) {
      const pad2 = (n: number) => (n < 10 ? '0' : '') + n;
      const mm = pad2(Math.floor(totalSec / 60));
      const ss = pad2(totalSec % 60);
      const showHMS = dp.showHMS !== false;
      const showSeconds = dp.showSeconds !== false;
      const out: { value: string; unit: string }[] = [];
      if (showHMS) {
        out.push({ value: mm, unit: 'MM' });
        if (showSeconds) out.push({ value: ss, unit: 'SS' });
      }
      if (out.length === 0) {
        return [
          { value: mm, unit: 'MM' },
          { value: ss, unit: 'SS' }
        ];
      }
      return out;
    }

    const hideDaysBecauseUnderOneDay =
      r.type === 'fixed_date' && !!r.endDate && totalSec < 86400;

    const ddn = Math.floor(totalSec / 86400);
    const hh = Math.floor((totalSec % 86400) / 3600);
    const mm = Math.floor((totalSec % 3600) / 60);
    const ss = totalSec % 60;
    const pad2 = (n: number) => (n < 10 ? '0' : '') + n;
    const padDd = (n: number) => {
      if (!Number.isFinite(n) || n <= 0) return '00';
      if (n < 100) return String(n).padStart(2, '0');
      return String(n);
    };
    const raw = { dd: padDd(ddn), hh: pad2(hh), mm: pad2(mm), ss: pad2(ss) };
    const showDays = dp.showDays !== false;
    const showHMS = dp.showHMS !== false;
    const showSeconds = dp.showSeconds !== false;
    const out: { value: string; unit: string }[] = [];
    const showDaysColumn =
      !hideDaysBecauseUnderOneDay &&
      (showDays || ddn > 0);
    if (showDaysColumn) {
      out.push({ value: raw.dd, unit: 'DD' });
    }
    if (showHMS) {
      out.push({ value: raw.hh, unit: 'HH' });
      out.push({ value: raw.mm, unit: 'MM' });
      if (showSeconds) {
        out.push({ value: raw.ss, unit: 'SS' });
      }
    }
    if (out.length === 0) {
      return [
        { value: raw.hh, unit: 'HH' },
        { value: raw.mm, unit: 'MM' },
        { value: raw.ss, unit: 'SS' }
      ];
    }
    return out;
  }

  /** 与 B 端 `styles.variant` / C 端 playbackStyle 1–4 对齐 */
  get extendedCountdownPreviewVariant(): 1 | 2 | 3 | 4 {
    const raw = this.formData.countdown?.styles?.variant;
    const str = String(raw == null || raw === '' ? '1' : raw);
    const m = str.match(/[1-4]/);
    const n = m ? parseInt(m[0], 10) : 1;
    return n >= 1 && n <= 4 ? (n as 1 | 2 | 3 | 4) : 1;
  }

  /** 预设 1、3 无单位间分隔符（与配置区预设缩略图一致）；2、4 保留 */
  get extendedCountdownPreviewShowBetweenUnitSeparators(): boolean {
    const v = this.extendedCountdownPreviewVariant;
    return v === 2 || v === 4;
  }

  /** 预设 3：翻页块外层（含中线视觉）；宽高由字体 + padding 决定，与扩展预览其他预设一致 */
  get extendedCountdownPreviewFlipOuterStyle() {
    const base = this.extendedCountdownPreviewDigitBoxStyle;
    return {
      ...base,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative' as const,
      overflow: 'hidden' as const,
      padding: '8px 10px',
      width: 'auto',
      minWidth: 0,
      boxSizing: 'border-box' as const,
      boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
    };
  }

  /** 预设 4：无底色时的数字行 */
  get extendedCountdownPreviewMinimalTextStyle() {
    const s = this.formData.countdown!.styles;
    return {
      color: s.textColor || '#1D2129',
      fontSize: (s.fontSize != null ? s.fontSize : 20) + 'px',
      fontFamily: s.fontFamily,
      fontWeight: 700,
      lineHeight: 1.15,
      letterSpacing: '0.02em'
    };
  }

  extendedCountdownSplitChars(segment: string): string[] {
    const t = String(segment == null ? '00' : segment);
    return t.length ? t.split('') : ['0', '0'];
  }

  get currentMobileRatio() {
    if (this.isMiddlePageSetting) {
      return this.getMiddleRuleValue('middleMobileRatio') || 'recommendRatio';
    } else if (this.activePageSetting === 'end') {
      return this.formData.rules.endMobileRatio || 'recommendRatio';
    }
    if (this.activePageSetting === 'end') {
      return this.formData.rules.endMobileRatio;
    }
    return this.formData.rules.mobileRatio;
  }

  // 获取当前页面的副按钮文案
  get currentSubButtonText() {
    const textMap: { [key: string]: string } = {
      start: this.formData.texts.subButton || '',
      middle: this.formData.texts.middleSubButton || '',
      end: this.formData.texts.endSubButton || ''
    };
    return this.isMiddlePageSetting
      ? (this.getMiddleTextValue('middleSubButton') || '')
      : (textMap[this.activePageSetting] || '');
  }

  // 获取当前页面的副按钮样式键名
  get currentThanksStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-thanks',
      middle: 'cartx-b-thanks__middle',
      end: 'cartx-b-thanks-end'
    };
    return this.isMiddlePageSetting
      ? this.getScopedMiddleStyleKey(styleKeyMap.middle)
      : (styleKeyMap[this.activePageSetting] || 'cartx-b-thanks');
  }

  // 获取当前页面的副按钮样式对象
  get currentThanksStyle() {
    const styleKey = this.currentThanksStyleKey;
    const styleMap = this.getScopedStyleMap(styleKey);
    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family']
    };
  }

  // 获取当前页面的活动文案文本
  get currentActivityText() {
    if (this.activePageSetting === 'start') {
      return this.formData.texts.activityTitle || '';
    } else if (this.isMiddlePageSetting) {
      // wheel2 新模板在步骤二如果未配置 middleActivityTitle，则回退使用 activityTitle
      if (this.isPopWheelCombo2) {
        return this.getMiddleTextValue('middleActivityTitle') || this.formData.texts.activityTitle || '';
      }
      return this.getMiddleTextValue('middleActivityTitle') || '';
    }
    return '';
  }

  // 获取当前页面的活动文案样式键名
  get currentActivityStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-activity',
      middle: 'cartx-b-activity__middle',
      end: 'cartx-b-activity'
    };
    return this.isMiddlePageSetting
      ? this.getScopedMiddleStyleKey(styleKeyMap.middle)
      : (styleKeyMap[this.activePageSetting] || 'cartx-b-activity');
  }

  // 获取当前页面的活动文案样式对象
  get currentActivityStyle() {
    const styleKey = this.currentActivityStyleKey;
    const styleMap = this.getScopedStyleMap(styleKey);
    const baseFontSize = (styleMap['font-size'] as string) || '16px';
    const fontSize = this.device === 'desktop' ? baseFontSize : parseFloat(baseFontSize) / 1.33 + 'px';

    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family'],
      fontSize,
      ...(this.formData.rules.adapterText && {
        fontWeight: 'bold',
        ...(this.device === 'phone' && { fontSize: [0, 8].includes(this.triggerEventType) ? '12px' : undefined })
      })
    };
  }

  // 获取当前页面的容器样式键名
  get currentContainerStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-wheel-container',
      middle: 'cartx-b-wheel-container__middle',
      end: 'cartx-b-wheel-container__end'
    };
    return this.isMiddlePageSetting
      ? this.getScopedMiddleStyleKey(styleKeyMap.middle)
      : (styleKeyMap[this.activePageSetting] || 'cartx-b-wheel-container');
  }

  // 获取当前页面的容器样式对象
  get currentContainerStyle() {
    const containerStyleKey = this.currentContainerStyleKey;
    const containerStyleMap = this.getScopedStyleMap(containerStyleKey);
    const borderRadius = containerStyleMap['border-radius'];

    // 获取 show 样式用于 fontFamily
    const showStyleMap = this.formData.styles.styleMap['cartx-b-show'] || {};

    const combo2Width =
      Number(this.popWindowWheel) === 2
        ? this.device === 'phone'
          ? ''
          : (this.isStyleSetting || this.isStyleSettingRoute)
            ? '660px'
            : '880px'
        : undefined;

    return {
      fontFamily: showStyleMap['font-family'],
      ...(combo2Width ? { width: combo2Width } : {}),
      ...(borderRadius
        ? {
            borderRadius,
            ...(this.device === 'phone' ? {} : { overflow: 'hidden' })
          }
        : {})
    };
  }

  get isStyleSettingRoute() {
    return (this.$route?.path || '').includes('/pop');
  }

  // 获取当前页面的背景框值（根据页面类型选择对应的 bgbox）
  get currentBgbox() {
    if (!this.formData.typesetting) {
      return false;
    }

    if (this.activePageSetting === 'start') {
      return this.formData.typesetting.bgbox;
    } else if (this.isMiddlePageSetting) {
      return this.getMiddleTypesettingValue('middleBgbox');
    } else {
      // end 页
      return (this.formData.typesetting as any).endBgbox || false;
    }
  }

  // 获取当前页面的背景框颜色（根据页面类型选择对应的 bgboxColor）
  get currentBgboxColor() {
    if (!this.formData.typesetting) {
      return undefined;
    }

    if (this.activePageSetting === 'start') {
      return this.formData.typesetting.bgboxColor;
    } else if (this.isMiddlePageSetting) {
      return this.getMiddleTypesettingValue('middleBgboxColor');
    } else {
      // end 页
      return (this.formData.typesetting as any).endBgboxColor;
    }
  }

  // 获取是否显示背景框的类名
  get shouldShowBackgroundBox() {
    if (this.device === 'phone') {
      return this.currentMobilePictureShow ? this.currentBgbox : false;
    }
    return this.currentBgbox;
  }

  // 获取当前页面的按钮样式键名
  get currentButtonStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-button',
      middle: 'cartx-b-button__middle',
      end: 'cartx-b-button-end'
    };
    return this.isMiddlePageSetting
      ? this.getScopedMiddleStyleKey(styleKeyMap.middle)
      : (styleKeyMap[this.activePageSetting] || 'cartx-b-button');
  }

  // 获取当前页面的按钮链接
  get currentButtonUrl() {
    if (this.activePageSetting === 'start') {
      return this.formData.rules.buttonAction === 'link'
        ? this.defineUrl(this.formData.rules.openUrl)
        : 'javascript:void(0)';
    } else if (this.isMiddlePageSetting) {
      // middle 页面的按钮逻辑，如果有 middleButtonAction 则使用，否则使用 start 的逻辑
      const middleButtonAction = this.getMiddleRuleValue('middleButtonAction') || this.formData.rules.buttonAction;
      const middleOpenUrl = this.getMiddleRuleValue('middleOpenUrl') || this.formData.rules.openUrl;
      return middleButtonAction === 'link' ? this.defineUrl(middleOpenUrl) : 'javascript:void(0)';
    } else {
      return this.formData.rules.endButtonAction === 'link'
        ? this.defineUrl(this.formData.rules.endOpenUrl)
        : 'javascript:void(0)';
    }
  }

  // 获取当前页面的按钮文本
  get currentButtonText() {
    if (this.activePageSetting === 'start') {
      return this.formData.texts.mainButton;
    } else if (this.isMiddlePageSetting) {
      return this.getMiddleTextValue('middleMainButton') || this.formData.texts.mainButton;
    } else {
      return this.currentSubscribeStatus === 'history'
        ? this.formData.texts.subscribedEndMainButton
        : this.formData.texts.endMainButton;
    }
  }

  // 获取当前页面的按钮样式对象
  get currentButtonStyle() {
    const buttonStyleKey = this.currentButtonStyleKey;
    const buttonStyleMap = this.getScopedStyleMap(buttonStyleKey);

    // 获取 show 下的按钮样式（优先级更高）
    const showButtonStyleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-show .cartx-b-button',
      middle: 'cartx-b-show__middle .cartx-b-button__middle',
      end: 'cartx-b-show .cartx-b-button-end'
    };
    const showButtonStyleKey = this.isMiddlePageSetting
      ? this.getScopedMiddleStyleKey(showButtonStyleKeyMap.middle)
      : (showButtonStyleKeyMap[this.activePageSetting] || 'cartx-b-show .cartx-b-button');
    const showButtonStyleMap = this.getScopedStyleMap(showButtonStyleKey);

    return {
      color: buttonStyleMap.color,
      fontFamily: buttonStyleMap['font-family'],
      background: showButtonStyleMap.background || buttonStyleMap.background,
      borderStyle: buttonStyleMap['border-style'],
      borderColor: buttonStyleMap['border-color'],
      borderRadius: buttonStyleMap['border-radius'],
      ...(this.formData.rules.adapterText && {
        fontWeight: 'inherit',
        fontSize: this.device === 'phone' && [0, 8].includes(this.triggerEventType) ? '12px' : '13px'
      })
    };
  }

  get imgPosition() {
    if (this.isMiddlePageSetting && (!this.isPopZhuanpan || this.isPopWheelCombo2)) {
      return this.getMiddleTypesettingValue('middleImgPosition');
    } else if (this.activePageSetting === 'end' && (!this.isPopZhuanpan || this.isPopWheelCombo2)) {
      return this.formData.typesetting?.endImgPosition;
    }
    return this.formData.typesetting?.imgPosition;
  }

  // 获取当前页面的图片 URL
  get currentImgUrl() {
    if (this.isMiddlePageSetting && !this.isPopZhuanpan) {
      return this.getMiddleTypesettingValue('middleImgUrl');
    } else if (this.isMiddlePageSetting && this.isPopWheelCombo2) {
      // 转盘组合布局步骤二页面使用 middleImgUrl
      return this.getMiddleTypesettingValue('middleImgUrl') || this.formData.typesetting?.imgUrl;
    } else if (this.activePageSetting === 'end' && !this.isPopZhuanpan) {
      return this.formData.typesetting?.imgUrlEnd;
    } else if (this.activePageSetting === 'end' && this.isPopWheelCombo2) {
      // 转盘组合布局结束页面使用 imgUrlEnd
      return this.formData.typesetting?.imgUrlEnd || this.formData.typesetting?.imgUrl;
    }
    return this.formData.typesetting?.imgUrl;
  }

  // 获取当前页面的背景图片 URL
  get currentBgImgUrl() {
    if (this.isMiddlePageSetting) {
      return this.getMiddleTypesettingValue('middleBgImgUrl');
    } else if (this.activePageSetting === 'end') {
      return this.formData.typesetting?.endBgImgUrl;
    }
    return this.formData.typesetting?.bgImgUrl;
  }

  // 新模板转盘底图字段：仅使用 wheelImgUrl。
  get currentWheelImgUrl() {
    return this.formData.typesetting?.wheelImgUrl;
  }

  // mode2：左侧转盘不使用上传后的 imgUrl，而使用“转盘背景图”字段（bgImgUrl / middleBgImgUrl / endBgImgUrl）
  get wheelLeftImgUrl() {
    return this.isPopWheelCombo2 ? this.currentBgImgUrl : this.currentImgUrl;
  }

  // 获取当前页面的指针图片 URL
  get currentPointImgUrl() {
    // 转盘配置统一使用开始页的配置
    return this.formData.typesetting?.pointImgUrl;
  }

  // 指针图片在转盘组合布局（popWindowWheel=2）中的落位
  get pointImgPosition() {
    return this.formData.typesetting?.pointImgPosition || 'middle';
  }

  // popWindowWheel=2：左转盘右图片组合
  get isPopWheelCombo2() {
    return this.isPopZhuanpan && Number(this.popWindowWheel) === 2;
  }

  // popWindowWheel=2 转盘布局位置：middle=文案与输入框中间，top=文案上方
  get wheelPosition() {
    return this.formData.typesetting?.wheelPosition || 'top';
  }

  // 获取当前页面的移动端图片显示设置
  get currentMobilePictureShow() {
    if (this.isMiddlePageSetting) {
      return this.getMiddleRuleValue('middleMobilePictureShow');
    }
    if (this.activePageSetting === 'end') {
      return this.formData.rules.endMobilePictureShow;
    }
    return this.formData.rules.mobilePictureShow;
  }

  // 当前页面隐私文案展示位置（按页面隔离）
  get currentPrivacyPosition() {
    const rules: any = this.formData.rules || {};
    // 后续如果有 middle / end 独立位置字段，可在这里扩展
    if (this.isMiddlePageSetting) {
      return this.getMiddleRuleValue('middlePrivacyPosition') || rules.privacyPosition;
    }
    return rules.privacyPosition;
  }

  // 获取当前页面隐私文案颜色（按页面隔离）
  get currentPrivacyColor() {
    const styleMap = this.formData.styles.styleMap;
    if (this.isMiddlePageSetting) {
      return this.getScopedStyleMap('cartx-b-privacy__middle')?.['color'];
    }
    return styleMap['cartx-b-privacy']?.['color'];
  }

  // 获取当前页面的指针角度
  get currentPointFinallyDeg() {
    // 转盘配置统一使用开始页的配置
    return this.formData.rules.pointFinallyDeg || 0;
  }

  // 获取当前页面的背景框样式
  get currentBgboxStyle() {
    const bgbox = this.currentBgbox;
    const bgboxColor = this.currentBgboxColor;

    console.log('currentBgboxStyle', bgbox);
    if (bgbox && bgboxColor) {
      console.log('currentBgboxStyle', bgboxColor);
      return `background:${bgboxColor};`;
    }
    return '';
  }

  // 获取当前页面的 Logo URL
  get currentLogoUrl() {
    if (this.activePageSetting === 'start') {
      return this.formData.logo && this.formData.logo.imgUrl;
    } else if (this.isMiddlePageSetting) {
      return this.getMiddleScopedValue(this.formData.logo as any, 'middleImgUrl');
    }
    return false;
  }

  // 获取当前页面的文本区域图片 URL
  get currentTextAreaImgUrl() {
    if (this.activePageSetting === 'start') {
      return this.formData.texts.textAreaImgUrl;
    } else if (this.isMiddlePageSetting) {
      return this.getMiddleScopedValue(this.formData.texts as any, 'middleTextAreaImgUrl');
    }
    return false;
  }

  // 获取内容区域的 class
  get contentClass() {
    return {
      'cartx-b-content-left': this.imgPosition === 'right',
      'cartx-b-content-right': this.imgPosition === 'left',
      'cartx-b-content-bottom': this.imgPosition === 'top',
      'cartx-b-content-middle': this.imgPosition === 'middle',
      'cartx-b-content-text-area':
        (this.formData.texts.textAreaImgUrl && this.activePageSetting === 'start') ||
        (this.currentTextAreaImgUrl && this.isMiddlePageSetting) ||
        (this.formData.texts.unsubscribedTextAreaImgUrl &&
          this.activePageSetting === 'end' &&
          this.currentSubscribeStatus === 'success') ||
        (this.formData.texts.subscribedTextAreaImgUrl &&
          this.activePageSetting === 'end' &&
          this.currentSubscribeStatus === 'history')
    };
  }

  get formStyle() {
    return Object.keys(this.formData.styles.styleMap)
      .map(className => {
        const styles = this.formData.styles.styleMap[className];
        if (!styles) return '';

        // 生成CSS规则，类选择器需要加点号
        const cssProps = Object.keys(styles)
          .map((item: string) => {
            return `${item}: ${styles[item]};`;
          })
          .join('\n        ');

        return `.${className} {
        ${cssProps}
      }`;
      })
      .filter(Boolean)
      .join('\n\n');
  }

  get enableFormOptimize() {
    return true;
  }

  get enableTenorSansFontFamily() {
    return CUSTOM_TENOR_SANS_FONT_COMPANY_ID.includes(getCompanyInfo().id || 0);
  }

  get enablePopinsFontFamily() {
    return CUSTOM_POPPINS_FONT_COMPANY_ID.includes(getCompanyInfo().id || 0);
  }

  get enableWheelCouponSetting() {
    return isEnableWheelCouponSetting() && this.formData.discountList && [1, 2].includes(Number(this.popWindowWheel));
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  get enableBannerEnglishPunctuationSpacing() {
    return isEnableBannerEnglishPunctuationSpacing();
  }

  get enableOnlyNewUserCustomStep() {
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    return isEnableOnlyNewUserCustomStep() && isOnlyNewUserTemplate(templateId);
  }

  get enableCustomStep() {
    if (!isEnableCustomStep() || [3, 5, 6].includes(this.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formData?.templateId || '');
    if (this.enableOnlyNewUserCustomStep) {
      return !DISABLE_CUSTOM_STEP_TPLID_NEW.includes(templateId);
    }
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  get iconStyles() {
    const { device, iconDynamicSizing } = this;

    // console.log('iconStyles before', JSON.stringify({
    //   device,
    //   iconWidth: this?.formData?.position?.iconWidth || '',
    //   iconDynamicSizing
    // }));

    if (!iconDynamicSizing) {
      // console.log('iconStyles', this.formData.position?.position, JSON.stringify(this.imgNameObj[this.formData.position?.position]));
      return this.imgNameObj;
    }

    let leftOrRight = '20px';
    if (this.device === 'phone') {
      leftOrRight = '0px';
    } else {
      leftOrRight = '20px';
    }

    // 动态尺寸icon固定100px 对齐C端
    let topOrBottom = '100px';

    // console.log('iconStyles', JSON.stringify({device, iconDynamicSizing, topOrBottom, leftOrRight}));
    return {
      LeftTop: { top: topOrBottom, left: leftOrRight },
      RightTop: { top: topOrBottom, right: leftOrRight },
      LeftMiddle: { top: '47%', left: leftOrRight },
      RightMiddle: { top: '47%', right: leftOrRight },
      LeftBottom: { bottom: topOrBottom, left: leftOrRight },
      RightBottom: { bottom: topOrBottom, right: leftOrRight }
    };
  }

  get iconSize() {
    const { device, iconDynamicSizing } = this;
    let width = (this.formData && this.formData.position && this.formData.position.iconWidth) || '';
    let height = (this.formData && this.formData.position && this.formData.position.iconHeight) || '';

    // console.log('iconSize before', JSON.stringify({
    //   device,
    //   iconDynamicSizing,
    //   iconSizeType: this.formData.position?.iconSizeType,
    //   width,
    //   height
    // }));

    if (this.formData.position && this.formData.position.iconSizeType) {
      switch (this.formData.position.iconSizeType) {
        case 'Small':
          width = 30;
          break;
        case 'Medium':
          width = 50;
          break;
        case 'Big':
          width = 80;
          break;
        default:
          width = 50;
          break;
      }
    }

    if (iconDynamicSizing) {
      switch ((this.formData.position && this.formData.position.iconSizeType) || '') {
        case 'Small':
          width = device === 'phone' ? 28 : 40;
          break;
        case 'Medium':
          width = device === 'phone' ? 35 : 50;
          break;
        case 'Big':
          width = device === 'phone' ? 46 : 65;
          break;
        default:
          width = device === 'phone' ? 35 : 50;
          break;
      }
    }

    // console.log('iconSize', JSON.stringify({
    //   device,
    //   iconDynamicSizing,
    //   iconSizeType: this.formData.position?.iconSizeType,
    //   width,
    //   height
    // }));

    return {
      width,
      height
    };
  }

  get currentPrivateHideCheckout() {
    return true;
    // const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    // return (companyId === 30 ||companyId === 565);
    // return false;
  }

  get currentSubscribeStatus() {
    // 默认显示订阅成功状态
    return this.subscribeStatus || 'success';
  }

  changeCountryCode(v) {
    this.selectedCountry.phoneCode = v.phoneCode;
    this.selectedCountry.countryAbbreviation = v.countryAbbreviation;
  }

  shouldRenderFormItem(item: any) {
    if (!item) return false;
    if (item.type === 'Email') {
      return (
        !this.enablePrivacySetting ||
        !this.formData.rules.stepDisplay ||
        (this.formData.rules.stepDisplay && this.step === '1') ||
        true
      );
    }
    if (item.type === 'Mobile Number') {
      return (
        !this.enablePrivacySetting ||
        !this.formData.rules.stepDisplay ||
        (this.formData.rules.stepDisplay && this.step === '2') ||
        true
      );
    }
    if (item.type === '自定义' && (!item.optionList || !item.optionList[0]) && item.questionType !== 'Date' && item.questionType !== 'Dropdown') {
      return false;
    }
    return true;
  }

  getFlagLocal(code: string) {
    if (typeof code == 'string') {
      const flag = phoneCode.find((item: any) => {
        return `+${item.CODE}` == code;
      });
      if (flag) {
        return `${flag.LOCAL}`.trim().toLocaleLowerCase();
      }
      return '';
    } else {
      const countryAbbr = (code && (code as any).countryAbbreviation) || '';
      return countryAbbr.trim().toLocaleLowerCase();
    }
  }

  @Watch('formData.position.iconUrl')
  calculateSize(newval: string) {
    // console.log('formData.position.iconUrl', newval);
    if (newval) {
      const img = new Image();
      img.src = newval;
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        // console.log('calculateSize aspect ratio:', width, height, width / height);
        const ratio = width / height;
        if (ratio < 0.7) {
          this.iconDynamicSizing = true;
          // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
        } else {
          this.iconDynamicSizing = false;
          // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
        }
      };
    } else {
      this.iconDynamicSizing = false;
      // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
    }
  }

  @Watch('formData.rules.countDown', { immediate: true })
  countDownChange(newval: number) {
    const sec = Math.max(0, Math.floor(Number(newval) || 0));
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    this.countDownM = m < 10 ? '0' + m : String(m);
    this.countDownS = s < 10 ? '0' + s : String(s);
  }

  @Watch('formData.start', { immediate: true, deep: true })
  startChange(newval: number) {
    if (this.activePageSetting === 'start') {
      // startOrEnd 是计算属性，会自动更新，不需要赋值
      if (this.startOrEnd) {
        this.startOrEnd.forEach(element => {
          if (element.type == 'Mobile Number') {
            if (element.phoneCountryAbbreviation) {
              this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
            }
            if (element.phoneCode) {
              this.selectedCountry.phoneCode = element.phoneCode;
            }
          }
        });
      }
    }
  }

  @Watch('startOrEnd', { immediate: true, deep: true })
  currentFormChange() {
    if (this.startOrEnd) {
      this.startOrEnd.forEach(element => {
        if (element.type == 'Mobile Number') {
          if (element.phoneCountryAbbreviation) {
            this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
          }
          if (element.phoneCode) {
            this.selectedCountry.phoneCode = element.phoneCode;
          }
        }
      });
    }
  }

  @Watch('formData.end', { immediate: true, deep: true })
  endChange(newval: number) {
    if (this.activePageSetting === 'end') {
      // startOrEnd 是计算属性，会自动更新，不需要赋值
      if (this.startOrEnd) {
        this.startOrEnd.forEach(element => {
          if (element.type == 'Mobile Number') {
            if (element.phoneCountryAbbreviation) {
              this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
            }
            if (element.phoneCode) {
              this.selectedCountry.phoneCode = element.phoneCode;
            }
          }
        });
      }
    }
  }

  @Watch('activePageSetting')
  activePageSettingChange(newval: number) {
    // startOrEnd 是计算属性，会自动根据 activePageSetting 更新，不需要赋值
    if (this.startOrEnd) {
      this.startOrEnd.forEach(element => {
        if (element.type == 'Mobile Number') {
          if (element.phoneCountryAbbreviation) {
            this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
          }
          if (element.phoneCode) {
            this.selectedCountry.phoneCode = element.phoneCode;
          }
        }
      });
    }
  }

  get bannerStyle() {
    let style = {
      background: `${this.formData.banner.backgroundColor}`,
      color: `${this.formData.banner.textColor}`,
      'font-size': `${this.formData.banner.fontSize}`,
      'font-family': `${this.formData.banner.font}`
    };
    style[this.formData.banner.position] = 0;
    return style;
  }

  get companyIs450() {
    // 方法不再调用，全量打开加购悬浮窗
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    return (
      companyId === 450 ||
      companyId === 30 ||
      companyId === 313 ||
      companyId === 721 ||
      companyId == 583 ||
      companyId === 608
    );
  }

  get companyIs475() {
    // 方法不再调用，全量打开加购悬浮窗
    const companyId = JSON.parse(localStorage.getItem('companyInfo') || '{}').id;
    return (
      companyId === 475 ||
      companyId === 30 ||
      companyId === 902 ||
      companyId === 965 ||
      companyId === 627 ||
      companyId === 571 ||
      companyId === 320 ||
      companyId === 494 ||
      companyId === 475 ||
      companyId === 896 ||
      companyId === 631 ||
      companyId === 1064 ||
      companyId === 455
    );
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.templateId}`;
    return (
      [1, 2].includes(Number(this.popWindowWheel)) ||
      tid === '36' ||
      tid === '37' ||
      tid === '38' ||
      tid === '39' ||
      tid === '40' ||
      tid === '42' ||
      tid === '43' ||
      `${this.id}` === '1e1609bc024d4517989039886ac7ed34' ||
      `${this.id}` === 'abdac5d809824d8280ffff395a854a15'
    );
  }

  get getCombinateType() {
    return (
      (this.formData && this.formData.combinationType) === 2 || `${this.id}` === 'f5210286e39243b5a296688eaa828f4e'
    );
  }

  get couponPrompt() {
    if (this.formData.discountList && Array.isArray(this.formData.discountList)) {
      // 查找第一个概率大于0的折扣项，返回其提示文案
      const item = this.formData.discountList.find(item => Number(item.rate) > 0);
      return item && item.couponPrompt ? item.couponPrompt : '';
    }
    return this.formData.texts.couponPrompt || '';
  }

  get isTieredDiscountTemplate() {
    const tid = `${Number(this.$route.query.templateid) || this.templateId}`;
    return tid === '210';
  }

  get isTieredMiddleCouponPage() {
    return this.isTieredDiscountTemplate && this.activePageSetting === 'middle';
  }

  // SKA2792: 中间页折扣码样式独立化——中间页 className 带 __middle 后缀,与结束页样式解耦
  get couponStyleSuffix() {
    return this.isTieredMiddleCouponPage ? '__middle' : '';
  }

  get currentCouponCodeType() {
    if (this.isTieredMiddleCouponPage) {
      return this.formData.rules?.middleCouponCodeType || this.formData.rules?.couponCodeType || '1';
    }
    return this.formData.rules?.couponCodeType || '1';
  }

  get showCurrentCoupon() {
    if (this.isTieredMiddleCouponPage) {
      return true;
    }
    return this.formData.rules.couponCodeShow && this.activePageSetting === this.formData.rules.couponCodePosition;
  }

  get currentCouponPrompt() {
    if (this.isTieredMiddleCouponPage) {
      return this.formData.texts?.middleCouponPrompt || '';
    }
    return this.couponPrompt;
  }

  get hasCurrentCouponPrompt() {
    return String(this.currentCouponPrompt || '').trim().length > 0;
  }

  get currentCouponCode() {
    // 使用但不返回这个变量，让计算属性依赖它
    const _ = this.discountTypeUpdated;

    if (this.isTieredMiddleCouponPage) {
      if (this.formData.middleDiscount) {
        return '动态显示折扣码';
      }
      return this.formData.rules?.middleCouponCode || 'coupon code';
    }

    if (this.formData.discountList) {
      const item = this.formData.discountList.find((item: any) => item.rate > 0);

      if (item && item.discountType === 2 && !!item.discount) {
        return '动态显示折扣码';
      } else {
        return (item && item.coupon) || 'coupon code';
      }
    }

    // console.log('currentCouponCode', this.formData.discountType, this.formData.discount);
    if (this.formData.discountType === 'dongtai' || !!this.formData.discount) {
      return '动态显示折扣码';
    }
    const couponCode = this.formData.rules.couponCode || 'coupon code';
    return couponCode;
  }
  get currentCouponCopy() {
    // SKA2792: 中间页折扣码预览时用 middleCouponCopyText
    if (this.isTieredMiddleCouponPage) {
      return this.middleCouponCopyText || this.couponCopyText || 'Copy';
    }
    return this.couponCopyText || 'Copy';
  }

  get bannerDisplayText() {
    const separator = this.enableBannerEnglishPunctuationSpacing ? ', ' : ',';
    const colon = this.enableBannerEnglishPunctuationSpacing ? ': ' : ':';
    return `${this.formData.banner.bannerName || ''}${separator}CODE${colon}${this.currentCouponCode}`;
  }

  defineUrl(url) {
    if (url.indexOf('https://') == -1 && url.indexOf('http://') == -1) {
      return 'http://' + url;
    } else {
      return url;
    }
  }

  getTimeNumberString(num: any) {
    if (Number(num) < 10) {
      return `0${num}`;
    } else {
      return `${num}`;
    }
  }

  setImgStyle(event: Event) {
    // 可以通过 event.target 获取到加载完成的图片元素
    const img = event.target as HTMLImageElement;
    // 进行样式设置
    let naturalWidth = img.naturalWidth;
    let naturalHeight = img.naturalHeight;
    if (naturalWidth > naturalHeight) {
      //横着的长方形
      this.imgWidth = '100%';
      this.imgHeight = 'auto';
    } else if (naturalWidth < naturalHeight) {
      //竖着的长方形
      this.imgWidth = 'auto';
      this.imgHeight = '100%';
    }
  }

  mounted() {
    // 监听折扣类型变化事件
    EventBus.$on('discount-type-changed', (type: any) => {
      // console.log('discount-type-changed', type);
      // 更新本地formData中的discountType
      if (this.formData) {
        this.$set(this.formData, 'discountType', type);
        // 每次更新时增加计数器，强制计算属性重新计算
        this.discountTypeUpdated++;

        // 强制更新视图
        this.$forceUpdate();
      }
    });
  }

  handleCloseClick() {
    // 关闭按钮点击事件
    this.$emit('close-popup');
  }

  beforeDestroy() {
    EventBus.$off('discount-type-changed');
  }
}
